// @flow
import {fromJS} from 'immutable';
import getQuestionDifficultiesFromQuestionSets from 'lib/getQuestionDifficultiesFromQuestionSets';
import getQuestionDifficultyTotalsFromList from 'lib/getQuestionDifficultyTotalsFromList';
import type {Exam as ExamModelV1} from 'resources/GeneratedModels/Exam/ExamModel.v1';

export default function createAssignmentMetadataFromPracticeExam(exam: ExamModelV1): Map<*, *> {
  const questionSets = exam.getSortedQuestionSets();
  const questionDifficulties = getQuestionDifficultiesFromQuestionSets(questionSets);
  const questionDifficultyTotals = getQuestionDifficultyTotalsFromList(questionDifficulties);
  return fromJS({
    breadcrumbs: [
      {
        name: `${exam.getSubject().getName()} | ${exam.getName()}`,
        url: null
      }
    ],
    breadcrumbLabel: `Assessment`,
    questionDifficultyTotals: questionDifficultyTotals,
    questionSetList: questionSets
  });
}
